import { EmptyState, EmptyStateIcon, Title } from '@patternfly/react-core'
import { SearchIcon } from '@patternfly/react-icons'
import { TableComposable, TableVariant, Tbody } from '@patternfly/react-table'
import * as React from 'react'
import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import type { IProgramEnrolment } from '@app/domain/program/program.interface'

import { ProgramListRow } from './program-list-row'

interface Props {
  onSendInteractionToIntakeAnywhere: (programInteractionId: string) => void
  onRevokeInteraction: (programInteractionId: string) => void
  patientProgramEnrolments: IProgramEnrolment[]
}

export const PatientProgramList = ({
  onSendInteractionToIntakeAnywhere,
  onRevokeInteraction,
  patientProgramEnrolments,
}: Props) => {
  const [expandedProgramNames, setExpandedProgramNames] = React.useState<
    string[]
  >([])
  const setProgramExpanded = (program: IProgramEnrolment, isExpanding = true) =>
    setExpandedProgramNames((prevExpanded) => {
      const otherExpandedProgramNames = prevExpanded.filter(
        (r) => r !== program.program.programId,
      )
      return isExpanding
        ? [...otherExpandedProgramNames, program.program.programId]
        : otherExpandedProgramNames
    })
  const isProgramExpanded = (programEnrolment: IProgramEnrolment) =>
    expandedProgramNames.includes(programEnrolment.program.programId)

  const history = useHistory()

  const handleProgramSelected = useCallback(
    (programEnrolment: IProgramEnrolment) => {
      history.push(`/clinic/program/${programEnrolment.program.programId}`)
    },
    [history],
  )

  if (patientProgramEnrolments.length > 0) {
    return (
      <TableComposable
        variant={TableVariant.compact}
        aria-label="Program Enrolments"
      >
        {patientProgramEnrolments.map((programEnrolment, idx) => {
          return (
            <Tbody
              key={programEnrolment.program.programId}
              isExpanded={isProgramExpanded(programEnrolment)}
            >
              <ProgramListRow
                programEnrolment={programEnrolment}
                key={idx}
                onProgramSelected={handleProgramSelected}
                rowIndex={idx}
                isProgramExpanded={isProgramExpanded(programEnrolment)}
                setProgramExpanded={setProgramExpanded}
                onSendInteractionToIntakeAnywhere={
                  onSendInteractionToIntakeAnywhere
                }
                onRevokeInteraction={onRevokeInteraction}
              />
            </Tbody>
          )
        })}
      </TableComposable>
    )
  } else {
    return (
      <EmptyState>
        <EmptyStateIcon icon={SearchIcon} />
        <Title headingLevel="h5" size="lg">
          No Programs found
        </Title>
      </EmptyState>
    )
  }
}
